import React, {
  createContext,
  useContext,
  useSyncExternalStore,
} from "react";
import PropTypes from "prop-types";

import {
  assertGuidesRuntime,
} from "../../../engines/StudioGuidesEngine";


const GuidesContext = createContext(null);


export function GuidesProvider({
  runtime,
  children,
}) {
  const validatedRuntime =
    assertGuidesRuntime(runtime);

  return (
    <GuidesContext.Provider value={validatedRuntime}>
      {children}
    </GuidesContext.Provider>
  );
}


GuidesProvider.propTypes = {
  runtime: PropTypes.shape({
    getCollection: PropTypes.func.isRequired,
    setCollection: PropTypes.func.isRequired,
    createGuide: PropTypes.func.isRequired,
    updateGuide: PropTypes.func.isRequired,
    moveGuide: PropTypes.func.isRequired,
    removeGuide: PropTypes.func.isRequired,
    lockGuide: PropTypes.func.isRequired,
    unlockGuide: PropTypes.func.isRequired,
    showGuide: PropTypes.func.isRequired,
    hideGuide: PropTypes.func.isRequired,
    clearGuides: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
};


export function useGuidesRuntime() {
  const runtime = useContext(GuidesContext);

  if (!runtime) {
    throw new Error(
      "useGuidesRuntime must be used inside GuidesProvider."
    );
  }

  return runtime;
}


export function useGuides() {
  const runtime = useGuidesRuntime();

  return useSyncExternalStore(
    runtime.subscribe,
    runtime.getCollection,
    runtime.getCollection,
  );
}


export default GuidesContext;
